/*global mm, matrix, cc_ */
define(
    "diy/undo-redo/historyEntry/Module",
    [
        'diy/undo-redo/historyEntry/Base',
        'diy/util/helper',
        'jquery'
    ],
    /**
     *
     * @param {module.undoRedo.HistoryEntry.Base} HistoryEntry
     * @param {diy.util.Helper} helper
     * @param {jQuery} $
     * @returns {*}
     */
    function (HistoryEntry, helper, $) {
        'use strict';
        var Module;
        /**
         * @class module.undoRedo.HistoryEntry.Module
         * @template module.undoRedo.HistoryEntry.Module
         * @lends {module.undoRedo.HistoryEntry.Module.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Module = HistoryEntry.extend({

            moduleId: null,
            messageAction: '',
            messageDetails: '',

            unserialize: function (serializedObject) {
                this.moduleId = serializedObject.moduleId;
                this.messageAction = serializedObject.messageAction || '';
                this.messageDetails = serializedObject.messageDetails || '';

                return this._super(serializedObject);
            },

            onSelect: function () {
                if (mm[this.moduleId] && mm[this.moduleId].modul) {
                    mm[this.moduleId].modul.toggleClass('undoRedo-highlight', true);
                }
            },

            onDeselect: function () {
                if (mm[this.moduleId] && mm[this.moduleId].modul) {
                    mm[this.moduleId].modul.toggleClass('undoRedo-highlight', false);
                }
            },

            onExecuted: function (executionData) {
                var
                    deferred = Q.defer(),
                    skipped = 'skipped',
                    addModule = function (entryData, scrollToIt) {
                        if (!matrix[entryData.payload.matrixId]) {
                            deferred.resolve(skipped);
                        } else {
                            matrix[entryData.payload.matrixId].addModule(
                                entryData.payload.moduleId,
                                entryData.payload.content.cms,
                                entryData.payload.content.edit,
                                entryData.payload.afterChildId,
                                scrollToIt
                            );
                        }
                    },
                    delModule = function (entryData, scrollToIt, triggerEvent) {
                        var myMatrix, matrixContainer;
                        if (typeof mm[entryData.payload.moduleId] !== 'undefined') {
                            myMatrix = matrix[mm[entryData.payload.moduleId].matrixId];

                            if (!myMatrix) {
                                // check for module in current page
                                matrixContainer = mm[entryData.payload.moduleId].modul.parent('.sortable-matrix');
                                if (matrixContainer.length) {
                                    myMatrix = matrix[matrixContainer.attr('data-matrixid')];
                                }
                            }
                        }

                        if (typeof myMatrix !== 'undefined') {
                            scrollToIt = (typeof scrollToIt === 'undefined') ? true : scrollToIt;
                            triggerEvent = (typeof triggerEvent === 'undefined') ? true : triggerEvent;

                            myMatrix.deleteModule(entryData.payload.moduleId, scrollToIt, triggerEvent);
                        } else {
                            deferred.resolve(skipped);
                        }

                    },
                    refreshModule = function (entryData, scrollToIt) {
                        if (typeof mm[entryData.payload.moduleId] !== 'undefined' && mm[entryData.payload.moduleId].inPage()) {
                            mm[entryData.payload.moduleId].refresh(scrollToIt);
                        } else {
                            deferred.resolve(skipped);
                        }
                    },

                    applyChanges = function (entryData, scrollToIt) {
                        switch (entryData.payload.actionType) {
                            case 'move':
                                if (mm[entryData.payload.moduleId]) {
                                    delModule(entryData, false, false);
                                }
                                addModule(entryData, scrollToIt);
                                break;
                            case 'change':
                                if (!mm[entryData.payload.moduleId]) {
                                    addModule(entryData, scrollToIt);
                                } else {
                                    refreshModule(entryData, scrollToIt);
                                }
                                break;
                            case 'add':
                                if (entryData.entryType === 'undo') {
                                    delModule(entryData, scrollToIt);
                                } else {
                                    if (mm[entryData.payload.moduleId]) {
                                        delModule(entryData, false, false);
                                    }
                                    addModule(entryData, scrollToIt);
                                }
                                break;
                            case 'delete':
                                if (entryData.entryType === 'undo') {
                                    if (mm[entryData.payload.moduleId]) {
                                        delModule(entryData, false, false);
                                    }
                                    addModule(entryData, scrollToIt);
                                } else {
                                    delModule(entryData, scrollToIt);
                                }
                                break;
                            default:
                                break;
                        }

                        return deferred.promise;
                    },
                    boundEvents = [
                        'diy-editor-undo-redo-no-action',
                        'diy-editor-module-refreshFinished',
                        'diy-editor-module-addFinished',
                        'diy-editor-module-deleteFinished',
                        'diy-editor-undo-redo-action-executed'
                    ].join(' ')
                    ;

                $(document).bind(boundEvents, function () {
                        deferred.resolve(true);
                    }
                );

                applyChanges(executionData, false).then(function () {
                    $(document).unbind(boundEvents);
                });

                return deferred.promise;
            },

            onExecutedLast: function (executionData) {
                try {
                    mm[this.moduleId].getContentContainer().scrollIntoView();
                } catch (e) {

                }

                // if this entry has execution results on another page and is the entry that user requested to be executed
                //      redirect the user to that page
                if (executionData.payload &&
                    executionData.payload.pageId > 0 &&
                    executionData.payload.pageId !== helper.getCurrentPageId()
                ) {
                    this.api.requestBrowserReload((cc_.properties.cmsUrl.slice(0, -1) + executionData.payload.pageUrl));
                }
            },

            serialize: function () {
                return {
                    moduleId: this.moduleId
                };
            },

            getLabel: function () {
                var label;
                if (this.messageAction.toString().length && this.messageDetails.toString().length) {
                    label = this.messageAction.toString()
                        .replace('%details%', '<span class="messageDetails">' + this.messageDetails.toString() + '</span>');
                } else {
                    label = this.getMessage();
                }
                return label;
            }
        });
        return Module;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/historyEntry/Module.js
 ** module id = 899
 ** module chunks = 0
 **/